<template>
  <div class="wrap_app">
    <div class="slide"></div>
    
    <div class="item" 
        v-for="item in list" :key="item.id">
        <div class="item2">
            <h1>{{ item.intro }}</h1>
            <p>{{ item.rec_time }}</p>
        </div>
        <div class="item2">
            <!-- <h1></h1>
            <p :class="[item.amount.includes('+') ? 'red' : '']">{{ item.amount }}</p> -->
            <h1 :class="[item.amount.includes('+') ? 'red' : '']">{{ item.amount }}</h1>
        </div>
    </div>
    <div class="loading nomore" v-if="isLoading">加载中...</div>
    <div class="nomore" v-if="!isLoading && !hasMore">{{ num_tips }}</div>
  </div>
</template>

<script>
import goldApi from '@/api/gold/detail.js'
import "@/utils/flexible";
import { scrollLoad } from "@/utils/index";
export default {
    data() {
        return {
            list:[],
            hasMore: true,
            isLoading: false,
            compare_to: 0,
            num_tips:'',
            start_time:'',//yyyy-MM-dd格式
            end_time:'',
        };
    },
    created() {
        this.getlist();   
    },
    mounted() {
        this.listenScrollFn();

        function handleSpecialCharacters(jsonStr) {
            let obj = {};
            if (jsonStr && Object.prototype.toString.call(jsonStr) == "[object String]" && jsonStr != 'null') {
                jsonStr = jsonStr.replace(/\n/g, "\<br/>");
                obj = JSON.parse(jsonStr)
            }
            return obj;
        }
        
        window.srNativeCallH5Method = (data) => {
            let params = null;
            if(source == 'ios') {
                params = JSON.parse(data);
            } else {
                params = handleSpecialCharacters(data);
            }
            if(params.method_name == 'gold_detail_time_select') {
                //接收app传过来的时间筛选并调用接口
                this.start_time = params.params.start_time;
                this.end_time = params.params.end_time;
                this.renew();
                
            } 
        };
    },
    methods:{
        renew(){
            this.list=[];
            this.hasMore= true;
            this.isLoading= false;
            this.compare_to= 0;
            this.num_tips='';
            this.getlist();
        },
        listenScrollFn() {
            window.document.addEventListener(
                "scroll",
                scrollLoad(this.columnListMore),
                false
            );
        },
        async columnListMore() {
            if (this.isLoading || this.compare_to === 0 || !this.hasMore) {
                return;
            }
            await this.getlist();
        },
        async getlist() {
            this.isLoading = true;
            let params = {
                before:this.compare_to,
            }
            if(this.start_time){
                params.start_time = this.start_time;
                params.end_time = this.end_time;
            }
            let res = await goldApi.user_gold_detail(params);
            this.isLoading = false;
            if(res.rslt == "succ") {
                if (res.info.length === 0) {
                    this.hasMore = false;
                    this.num_tips = res.num_tips;
                }
                else{
                    this.list = this.list.concat(res.info);
                    this.compare_to = this.list[this.list.length-1].timestamp;
                }
            }
            else {
                this.hasMore = false;
                this.num_tips = res.num_tips;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/sass/global.scss";
    .wrap_app{
        background: #fff;
    }
    .slide{
        background: #F5F6F7;
        height: rem2(10px);
    }
    .nomore{
        padding: rem2(10px) rem2(12px);
        font-size: rem2(15px);
        color: #939393;
        text-align: center;
    }
    .item{
        display: flex;
        width: 100%;
        padding: rem2(10px) rem2(12px);
        box-sizing: border-box;
        background: #fff;
        border-bottom: 1px solid #EBEBEB;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .item2{
            >h1{
                color: #333;
                font-size: rem2(15px);
                font-style: normal;
                font-weight: 400;
                line-height: rem2(20px); 
            }
            >p{
                color: #939393;
                font-size: rem2(13px);
                font-style: normal;
                font-weight: 400;
                line-height: rem2(18px); 
            }
            .red{
                color: #FF0000;
            }
        }
    }
</style>